import { SET_USER_INFOS } from './types';

export function setUserInfo(userId, userInfo) {
	return {
		type: SET_USER_INFOS,
		userId,
		userInfo
	};
}